<template>
  <VTableLocal
    :items="displayedItems"
    :showRowIcon="true"
    :itemActions="getItemActions"
    centerColumns="['action']"
    :headers="tableHeaders"
    :disablePagination="true"
    @iconAction="onClickAction"
  />
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import { isEmpty } from 'lodash';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import DeviceAnalysisKeyOptionForm from './deviceAnalysisKeyOptionForm.vue';

export default {
    name: 'DeviceAnalysisKeyOptions',
    components: {
        VTableLocal,
    },
    props: {
        // options of the device analysis key
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'userLang',
            'teamMainLang',
        ]),
        tableHeaders() {
            return [
                'option',
                'method',
                'minimum',
                'maximum',
            ].map(header => ({
                text: this.$t(`deviceAnalysisKeys.options.${header}`),
                value: header,
            }));
        },
        getItemActions() {
            const actions = [];
            if (this.hasPermission('deviceAnalysisKeys.edit')) {
                actions.push({
                    name: this.$t('forms.btn.edit'),
                    icon: 'edit',
                    mode: 'edit',
                });
            }
            if (this.hasPermission('deviceAnalysisKeys.remove')) {
                actions.push({
                    name: this.$t('forms.btn.delete'),
                    icon: 'delete',
                    mode: 'delete',
                    iconAndTextColor: '#EF4135',
                });
            }
            return actions;
        },
        displayedItems() {
            if (!this.item.options.length) return [];

            return this.item.options.map((op, index) => ({
                index,
                ...op,
                option: op.option[this.userLang] || op.option[this.teamMainLang],
                method: op.method[this.userLang] || op.method[this.teamMainLang],
            }));
        },
    },
    methods: {
        async onClickAction(item, action) {
            const { data: key } = await this.$rq.getDeviceAnalysisKey(this.item.id);
            const originalOption = key.options[item.index];
            if (action.mode === 'edit') {
                this.$root.$emit('showModal', {
                    title: this.$t('deviceAnalysisKeys.actions.update'),
                    component: Vue.component('deviceAnalysisKeyOptionForm', DeviceAnalysisKeyOptionForm),
                    payload: {
                        item: key,
                        option: originalOption,
                        isEdition: true,
                    },
                    showLangs: true,
                    onConfirm: requestPayload => this.updateOption(item, requestPayload, key),
                });
            }
            if (action.mode === 'delete') {
                this.$root.$emit('showModal', {
                    title: this.$t('deviceAnalysisKeys.actions.remove'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: { msg: this.$t('deviceAnalysisKeys.actions.confirmRemove') },
                    onConfirm: () => this.deleteDeviceAnalysisKeyOption(item, key),
                    isForm: false,
                });
            }
        },
        async updateOption(option, requestPayload, key) {
            if (isEmpty(requestPayload)) return;

            const deviceAnalysisKey = { ...key };
            deviceAnalysisKey.options[option.index] = requestPayload;

            const { data: updatedKey } = await this.$rq.updateDeviceAnalysisKey(deviceAnalysisKey.id, deviceAnalysisKey);
            this.$emit('refreshKeys', updatedKey);
        },
        async deleteDeviceAnalysisKeyOption(optionToDelete, key) {
            const deviceAnalysisKey = { ...key };
            deviceAnalysisKey.options.splice(optionToDelete.index, 1);
            const { data: updatedKey } = await this.$rq.updateDeviceAnalysisKey(deviceAnalysisKey.id, deviceAnalysisKey);
            this.$emit('refreshKeys', updatedKey);
        },
    },
};
</script>
